
        <ion-content>
            <component-wallet
                    [certificateList]="certificateList"
                    [users]="users"
                    (onItemClick)="onInternalItemClick($event)"
            ></component-wallet>
        </ion-content>
    